/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Liability_S61_Item_4Inputs */

const es_tyc_liability_s61_item_4 = /** @type {(inputs: Tyc_Liability_S61_Item_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reclamaciones basadas en el incumplimiento de obligaciones de seguridad provenientes de acciones de terceros.`)
};

const en_tyc_liability_s61_item_4 = /** @type {(inputs: Tyc_Liability_S61_Item_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claims based on breach of security obligations arising from third-party actions.`)
};

/**
* | output |
* | --- |
* | "Claims based on breach of security obligations arising from third-party actions." |
*
* @param {Tyc_Liability_S61_Item_4Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_liability_s61_item_4 = /** @type {((inputs?: Tyc_Liability_S61_Item_4Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Liability_S61_Item_4Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_liability_s61_item_4(inputs)
	return en_tyc_liability_s61_item_4(inputs)
});
export { tyc_liability_s61_item_4 as "tyc.liability.s61_item_4" }